export default "__VITE_ASSET__e2348620__"